import { render } from "./IconInfo.vue?vue&type=template&id=20892c66"
import script from "./IconInfo.vue?vue&type=script&lang=js"
export * from "./IconInfo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__